import { Record } from 'immutable';

export const ImageFactory = new Record({
  src: '',
  originalSizeSrc: '',
  initialIndex: 0,
});

export const test = 200;
